import React, { useContext, useEffect, useState } from 'react'

import styled from 'styled-components'

import { Web3Context } from '../hooks/web3'

import { useProviderStatusState } from '../hooks/useProviderStatusState'
import { createWalletEvent } from 'user-events-segment'
import { getProviderType } from './connection/provider'
import { getNetworkName } from '../config'

const _AppStatus = styled.div`
  font-family: Montserrat;
  align-items: center;
  display: flex;
  border-radius: 1rem;
  font-size: 1.5rem;
  opacity: 0.8;
  padding: 5px;
`

const AppOutdated = styled(_AppStatus)`
  color: ${({ theme }) => theme.appStatusColorOutdated};
  background-color: ${({ theme }) => theme.appStatusBackgroundColorOutdated};
  border: 1px solid ${({ theme }) => theme.appStatusBorderColorOutdated};
`

const Title = styled.h3`
  font-size: 1.5rem;
  padding: 0.2rem;
  margin: 0 10px;
`
const Paragraph = styled.p`
  font-size: 1rem;
  padding: 0.2rem;
  max-width: 300px;
  margin: 0 10px;
`

const AppUpToDate = styled(_AppStatus)`
  color: white;
  color: ${({ theme }) => theme.appStatusColorUpToDate};
`

const AppStatusContainer = styled.div`
  //padding-top: 1rem;
  display: flex;
  padding-bottom: 1rem;
  padding-right: 1rem;
  justify-content: flex-end;
`

function refreshPage() {
  window.location.reload()
}

function AppStatus() {
  const { isConnectedToWeb3, appChainID } = useContext(Web3Context)

  // outdated : means the node delay is above DEADLINE
  const { outdated, count } = useProviderStatusState()
  const [displayed, setDisplayed] = useState(false)
  const [wasDisplayed, setWasDisplayed] = useState(false)
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    if (count >= 2 && !wasDisplayed) {
      const offline = !window.navigator.onLine
      if (offline) {
        setWasOffline(true)
      }
      createWalletEvent().app_status_popup_displayed(
        getProviderType(),
        getNetworkName(appChainID),
        offline ? 'offline' : 'node_down'
      )
      setDisplayed(true)
      setWasDisplayed(true)
    }

    if (count === 0 && displayed) {
      // reset, then wasDisplayed will reset
      setDisplayed(false)
    }
  }, [count])

  useEffect(() => {
    if (!displayed && wasDisplayed) {
      // wasDisplayed effect
      console.log('sending removed', count, displayed, wasDisplayed)
      createWalletEvent().app_status_popup_removed(
        getProviderType(),
        getNetworkName(appChainID),
        wasOffline ? 'offline' : 'node_down'
      )

      // end of wasDisplayed effect
      setWasOffline(false)
      setWasDisplayed(false)
    }
  }, [displayed])

  return (
    <>
      {isConnectedToWeb3 && (
        <AppStatusContainer>
          {count >= 2 ? (
            <AppOutdated>
              <div>
                <Title>Network Warning</Title>
                <Paragraph>
                  Polygon might be down right now, or you may have lost your
                  network connection.
                </Paragraph>
              </div>
            </AppOutdated>
          ) : (
            <div></div>
          )}
        </AppStatusContainer>
      )}
    </>
  )
}

export default AppStatus
